import { EngagementErrorDialogDataModel } from './engagement-error-dialog-data.model';

export class EngagementDocumentAlteredBeforeSigningStrategyModel implements EngagementErrorDialogDataModel {

  engagementId: number;

  constructor(engagementId: number) {
    this.engagementId = engagementId;
  }

  getTitle() { return 'Sorry, the document you tried to sign is out of date.'; }
  getMessage() { return 'Reload to see the latest version and try again.'; }
  getImagePath() { return 'out-of-date.png'; }
  getButtonText() { return 'Reload'; }
  getRoutePath() { return ''; }
}
